import { enqueueSnackbar } from "notistack";

export const handleApiError = (error) => {
  if (error?.response) {
    const { status, data } = error.response;

    // Laravel Validation Error (422)
    if (status === 422 && data?.errors) {
      Object.values(data.errors).forEach((messages) => {
        if (Array.isArray(messages)) {
          messages.forEach((msg) => enqueueSnackbar(msg, { variant: "error" }));
        } else if (typeof messages === "string") {
          enqueueSnackbar(messages, { variant: "error" });
        }
      });
    }
    // Check if backend returned a string error in message.errors
    else if (data?.message?.errors) {
      if (typeof data.message.errors === "string") {
        enqueueSnackbar(data.message.errors, { variant: "error" });
      } else if (Array.isArray(data.message.errors)) {
        data.message.errors.forEach((msg) => enqueueSnackbar(msg, { variant: "error" }));
      } else if (typeof data.message.errors === "object") {
        Object.values(data.message.errors).forEach((msgs) => {
          Array.isArray(msgs)
            ? msgs.forEach((msg) => enqueueSnackbar(msg, { variant: "error" }))
            : enqueueSnackbar(msgs, { variant: "error" });
        });
      }
    }
    // Internal Server Error (500)
    else if (status === 500) {
      enqueueSnackbar(data?.message || "Internal server error", { variant: "error" });
    }
    // Other status codes
    else {
      enqueueSnackbar(data?.message || "Something went wrong", { variant: "error" });
    }
  } else {
    // No response (network error, timeout, etc.)
    enqueueSnackbar("Network error. Please try again later.", { variant: "error" });
  }
};
